// extracted by mini-css-extract-plugin
module.exports = {"button":"CookiePreferencesButton_button__qBZ5T"};